// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2hn1x","noInteraction":"EventWrapper_noInteraction__1LuIL","pointerPassthrough":"EventWrapper_pointerPassthrough__3tA-0"};